import React from 'react';
import { Box, Text } from '@goodrx/matisse';

export const CouponNotFound: React.FC = () => {
  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Text fontWeight={600} lineHeight="22px">
          No coupon found
        </Text>

        <Box>
          <img src="/images/logo-goodrx.png" alt="GoodRx Logo" width="60" />
        </Box>
      </Box>

      <Box>
        <Text color="greyDarker" fontWeight={500}>
          We’re unable to find a coupon for this pharmacy or prescription.
        </Text>
      </Box>
    </>
  );
};
